import {
  Container,
  AnimatedContainer,
  BackgroundImageContainer,
  BackgroundImage,
  LeftSection,
  RightSection,
  CpfSection,
  CpfLabel,
  CpfInput,
  Calculator,
  NumberGrid,
  NumberButton,
  BackspaceButton,
  SubmitButton,
  LanguageSelectorContainer,
  SubmitButtonPP,
  TopRightContainer,
  ActionButton,
  CredentialCard,
  CredentialsListContainer,
  CredentialsPageTitle,
  LabelCard,
  PrintButton,
  ContainerButton,
  AreaTitle,
  ReturnButton,
  CredencialsWrapper,
} from "./styles";
import { useCallback, useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import LanguageSelector from "../../components/LanguageSelector";
import VirtualKeyboard from "../../components/VirtualKeyboard";
import AccessCodeConfirmationModal from "../../components/AccessCodeConfirmationModal";
import useNotification from "../../hooks/newUXNotification";
import { useLoading } from "../../hooks/loading";
import LoadingOverlay from "../../components/LoadingOverlay";
import { useHistory } from "react-router-dom";
import { changeApplicationLanguage } from "../../redux/modules/language/actions";
import IdleTimer from "react-idle-timer/dist/index.es.js";
import SignOut from "../../newUXAssets/icons/SignOut";
import { PDFDocument, rgb } from "pdf-lib";
import { printPdfKioskSafe } from "../../utils/printPdfKioskSafe";

import { AiOutlinePrinter } from "react-icons/ai";
import { PiWarningCircle } from "react-icons/pi";
import {
  getCredentialsByDocument,
  getTotem,
  logoutShutdownTotem,
  reprintCredentialTotem,
  totemHeartbeat,
} from "../../service/selfservice.service";
import ModalNotification from "./components/ModalNotification/";
import CredenticalImagePreview from "./components/CredentialsImagePreview";
import { BsPrinterFill } from "react-icons/bs";
import { IoReturnDownBackOutline } from "react-icons/io5";
import { FaPrint } from "react-icons/fa6";
import { Tooltip } from "antd";
import { getAllTemplatesOfTotem } from "../../service/credentials.service";
import { getTotemPosition } from "../../utils/totemPosition";

export const SelfService = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { code } = useSelector((state) => state.language);
  const [cpfValue, setCpfValue] = useState("");
  const [passportValue, setPassportValue] = useState("");
  const [showVirtualKeyboard, setShowVirtualKeyboard] = useState(false);
  const passportInputRef = useRef(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showReprintModal, setShowReprintModal] = useState(false);
  const totem = localStorage.getItem("totemName");
  const slug = localStorage.getItem("slugName");
  const timeoutRef = useRef(null);
  const [infoNotificationModalByCode, setInfoNotificationModalByCode] =
    useState();
  const [isOpenModalByCode, setIsOpenModalByCode] = useState(false);
  const [storedTotem, setStoredTotem] = useState(null);
  const notification = useNotification();
  const { handleLoading } = useLoading();
  const history = useHistory();
  const [viewCredentials, setViewCredentials] = useState(false);
  const [viewForms, setViewForms] = useState(true);
  const [credentialsList, setCredentialsList] = useState([]);
  const [selectedCredential, setSelectedCredential] = useState(null);
  const [waitingForPrintAssemble, setWaitingForPrintAssemble] = useState(false);
  const [waitingLoadingButton, setWaitingLoadingButton] = useState(false);
  const [templateCache, setTemplateCache] = useState({});
  const [printConfiguration, setPrintConfiguration] = useState(null);
  const heartbeatIntervalRef = useRef(null);

  const CONSTANT_RESPONSE_CODES = {
    printedSuccess: 32001,
    reprintedSuccess: 15014,
    printedError: -32001,
    noCredentialAssociated: -13027,
    alreadyPrinted: -13029,
    unregisteredContributor: -13030,
    multipleAssociatedCredentials: -13015,
    cannotPrintOneOrMoreCredentials: -44000,
    permissionDenied: -1002,
  };

  const isEnglish = code === "en";
  const isPortuguese = code === "pt";
  const DEBOUNCE_TIME = 500;
  const IDLE_TIMEOUT =
    Number(process.env.REACT_APP_TIMEOUT_INACTIVE_TOTEM) || 30000;
  const HEARTBEAT_INTERVAL =
    Number(process.env.REACT_APP_TOTEM_HEARTBEAT_INTERVAL) || 300000;

  useEffect(() => {
    if (isEnglish && viewForms) {
      setShowVirtualKeyboard(true);

      setTimeout(() => {
        passportInputRef.current?.focus();
      }, 0);
    } else if (isPortuguese && viewForms) {
      setShowVirtualKeyboard(false);
    }
  }, [isEnglish, isPortuguese, viewForms]);

  const enterFullscreen = async () => {
    try {
      // Verifica se a API de fullscreen está disponível
      if (
        !document.documentElement.requestFullscreen &&
        !document.documentElement.webkitRequestFullscreen &&
        !document.documentElement.msRequestFullscreen
      ) {
        console.warn("API de fullscreen não está disponível neste navegador");
        return;
      }

      // Tenta entrar em fullscreen
      if (document.documentElement.requestFullscreen) {
        await document.documentElement.requestFullscreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        await document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        await document.documentElement.msRequestFullscreen();
      }
    } catch (err) {
      console.warn("Erro ao tentar entrar em fullscreen:", err);

      // Se falhar, pode ser devido à política de segurança do navegador
      if (err.name === "NotAllowedError") {
        console.warn(
          "Fullscreen bloqueado pela política de segurança do navegador. É necessária interação do usuário."
        );
      }
    }
  };

  document.addEventListener("fullscreenchange", function (e) {
    if (!document.fullscreenElement) {
      // desativa modo tela cheia
      enterFullscreen();
    }
  });

  const handleWaitingForPrintAssemble = useCallback((flag) => {
    setWaitingForPrintAssemble(flag);
  }, []);

  const getStoredTotem = async (token) => {
    handleLoading(true);
    try {
      const responseStoredTotem = await getTotem(token, slug);

      if (!storedTotem) setStoredTotem(responseStoredTotem.data);

      // NÃO atualiza printConfiguration aqui - essa API não retorna esse campo
      // printConfiguration vem apenas do login (/auth/totem) e fica no localStorage
    } catch (error) {
      // Se token vencido (401), redirecionar para login do slug
      if (error.response?.status === 401) {
        console.warn(
          "[Totem] Token expirado ao buscar dados. Redirecionando para login."
        );
        clearLocalStorageOnExit();
        history.push(`/totem/${slug}`);
        return;
      }

      notification.displayError(
        "Erro ao recuperar os detalhes do totem. Você foi redirecionado para a tela inicial."
      );
      history.push(`/totem/${slug}`);
    } finally {
      handleLoading(false);
    }
  };

  const getTokenFromLocalStorage = useCallback(() => {
    try {
      const storedToken = localStorage.getItem("token");
      return storedToken;
    } catch (error) {
      console.warn("Erro ao recuperar o token:", error);
      return null;
    }
  }, []);

  /**
   * Inicia sistema de heartbeat para manter sessão ativa
   * Envia ping a cada 5 minutos (300000ms) após 30 segundos iniciais
   */
  const startHeartbeat = useCallback(() => {
    // Limpa qualquer intervalo existente
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
    }

    const token = localStorage.getItem("token");
    const currentSlug = localStorage.getItem("slugName");

    if (!token) {
      console.warn("[Heartbeat] Token não encontrado. Heartbeat não iniciado.");
      return;
    }

    if (!currentSlug) {
      console.warn("[Heartbeat] Slug não encontrado. Heartbeat não iniciado.");
      return;
    }

    // Primeiro ping após 30 segundos
    setTimeout(async () => {
      try {
        await totemHeartbeat(token);
      } catch (error) {
        console.error("[Heartbeat] Erro no ping inicial:", error);
        // Se erro 401, sessão expirou - redirecionar para login
        if (error.response?.status === 401) {
          console.warn(
            "[Heartbeat] Sessão expirada. Redirecionando para login do slug:",
            currentSlug
          );
          stopHeartbeat();
          history.push(`/totem/${currentSlug}`);
        }
      }
    }, 30000);

    // Intervalo de 5 minutos
    heartbeatIntervalRef.current = setInterval(async () => {
      try {
        await totemHeartbeat(token);
      } catch (error) {
        console.error("[Heartbeat] Erro ao enviar ping:", error);
        // Se erro 401, sessão expirou - redirecionar para login
        if (error.response?.status === 401) {
          console.warn(
            "[Heartbeat] Sessão expirada. Redirecionando para login do slug:",
            currentSlug
          );
          stopHeartbeat();
          history.push(`/totem/${currentSlug}`);
        }
      }
    }, HEARTBEAT_INTERVAL);
  }, [history, HEARTBEAT_INTERVAL]);

  /**
   * Para o sistema de heartbeat
   */
  const stopHeartbeat = useCallback(() => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
      heartbeatIntervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    const token = getTokenFromLocalStorage();

    // Só carrega templates se printConfiguration for "TEMPLATE"
    // Se não for TEMPLATE (incluindo STAMP ou null), não carrega
    if (!token || !printConfiguration || printConfiguration !== "TEMPLATE")
      return;

    const fetchTemplates = async () => {
      handleLoading(true);

      try {
        const response = await getAllTemplatesOfTotem(token);

        const cache = response.data.reportOutputList.reduce((acc, template) => {
          acc[template.s3FileKey] = template.file;
          return acc;
        }, {});

        setTemplateCache(cache);
      } catch (error) {
        // Se token vencido (401), redirecionar para login do slug
        if (error.response?.status === 401) {
          console.warn(
            "[Totem] Token expirado ao buscar templates. Redirecionando para login."
          );
          clearLocalStorageOnExit();
          history.push(`/totem/${slug}`);
          return;
        }

        notification.displayError(
          intl.formatMessage({
            id: "api.error." + error.response?.data?.code,
          })
        );
      } finally {
        handleLoading(false);
      }
    };

    fetchTemplates();
  }, [printConfiguration]);

  useEffect(() => {
    const token = getTokenFromLocalStorage();

    if (token) {
      // Recupera printConfiguration do localStorage (salvo no login)
      const storedPrintConfig =
        localStorage.getItem("printConfiguration") || "STAMP";
      setPrintConfiguration(storedPrintConfig);

      // Busca dados do totem
      getStoredTotem(token);
    } else {
      history.push(`/totem/${slug}`);
    }
  }, [getTokenFromLocalStorage, history, slug]);

  /**
   * useEffect para gerenciar heartbeat
   * Inicia quando há token e para ao desmontar componente
   */
  useEffect(() => {
    const token = getTokenFromLocalStorage();

    if (token) {
      // Iniciar heartbeat quando componente monta com token válido
      startHeartbeat();
    }

    // Cleanup: parar heartbeat ao desmontar
    return () => {
      stopHeartbeat();
    };
  }, [startHeartbeat, stopHeartbeat, getTokenFromLocalStorage]);

  const clearLocalStorageOnExit = () => {
    try {
      // Limpa localStorage MAS MANTÉM posição salva (totem_position_{slug})
      localStorage.removeItem("accessCode");
      localStorage.removeItem("token");
      localStorage.removeItem("printConfiguration");

      // Limpa estados para garantir reset completo
      setPrintConfiguration(null);
      setTemplateCache({});
      setStoredTotem(null);
      setCredentialsList([]);
      setSelectedCredential(null);

      // IMPORTANTE: NÃO remove totem_position_{slug} do localStorage
    } catch (error) {
      console.warn("Erro ao limpar localStorage:", error);
    }
  };

  // Limpa localStorage APENAS quando sair ou atualizar a página
  useEffect(() => {
    window.addEventListener("beforeunload", clearLocalStorageOnExit);

    return () => {
      window.removeEventListener("beforeunload", clearLocalStorageOnExit);
    };
  }, []);

  // Força fullscreen e bloqueia teclas para sair do modo fullscreen
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F11" || event.keyCode === 122) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
      if (event.key === "Escape" || event.keyCode === 27) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    };

    const handleKeyUp = (event) => {
      if (
        event.key === "F11" ||
        event.keyCode === 122 ||
        event.key === "Escape" ||
        event.keyCode === 27
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    };

    const handleKeyPress = (event) => {
      if (
        event.key === "F11" ||
        event.keyCode === 122 ||
        event.key === "Escape" ||
        event.keyCode === 27
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    };

    // Impede que o usuário saia do fullscreen
    const handleFullscreenChange = () => {
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        enterFullscreen();
      }
    };

    // Bloqueia o clique direito do mouse
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("keyup", handleKeyUp, true);
    document.addEventListener("keypress", handleKeyPress, true);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("keyup", handleKeyUp, true);
      document.removeEventListener("keypress", handleKeyPress, true);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  const resetProcess = (timeLimit = false) => {
    setCpfValue("");
    setPassportValue("");
    setShowVirtualKeyboard(false);

    if (timeLimit) {
      notification.displayInfo(
        "O totem excedeu o tempo limite de inatividade e foi recarregado."
      );
    }
  };

  const resetModalByCode = () => {
    // Cancelar o timeout ativo se existir
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    setIsOpenModalByCode(false);
    setInfoNotificationModalByCode(undefined);
  };

  const resetLanguage = () => {
    if (!isPortuguese) {
      dispatch(changeApplicationLanguage({ code: "pt" }));
    }
  };

  // Funções para a calculadora
  const formatCpf = useCallback((value) => {
    // Remove tudo que não é dígito
    const digits = value.replace(/\D/g, "");

    // Aplica a máscara do CPF: 000.000.000-00
    return digits
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  }, []);

  const handleNumberClick = useCallback(
    (number) => {
      if (cpfValue.replace(/\D/g, "").length < 11) {
        const newValue = cpfValue.replace(/\D/g, "") + number;
        setCpfValue(formatCpf(newValue));
      }
    },
    [cpfValue, formatCpf]
  );

  const handleBackspace = useCallback(() => {
    const digits = cpfValue.replace(/\D/g, "");
    const newDigits = digits.slice(0, -1);
    setCpfValue(formatCpf(newDigits));
  }, [cpfValue, formatCpf]);

  const handleSubmit = useCallback(async () => {
    try {
      setWaitingLoadingButton(true);
      const token = getTokenFromLocalStorage();

      if (isPortuguese) {
        const digits = cpfValue.replace(/\D/g, "");

        if (digits.length < 11) {
          notification.displayError(
            intl.formatMessage({ id: "selfService.cpf.incomplete" })
          );

          return;
        }

        const responseCredentials = await getCredentialsByDocument(
          token,
          digits
        );

        if (
          responseCredentials.status === 200 &&
          responseCredentials.data.credentials.length > 0
        ) {
          setCredentialsList(responseCredentials.data.credentials || []);
          setViewCredentials(true);
          setViewForms(false);
        } else {
          notification.displayError(
            intl.formatMessage({ id: "selfService.noCredentialsFound" })
          );
        }
      } else if (isEnglish) {
        if (passportValue.trim().length < 6) {
          notification.displayError(
            intl.formatMessage({ id: "selfService.passport.incomplete" })
          );

          return;
        }

        const responseCredentials = await getCredentialsByDocument(
          token,
          passportValue.trim()
        );

        if (
          responseCredentials.status === 200 &&
          responseCredentials.data.credentials.length > 0
        ) {
          setCredentialsList(responseCredentials.data.credentials || []);
          setViewCredentials(true);
          setViewForms(false);
          setShowVirtualKeyboard(false);
        } else {
          notification.displayError(
            intl.formatMessage({ id: "selfService.noCredentialsFound" })
          );
        }
      }
    } catch (error) {
      handleLoading(false);
      setCredentialsList([]);

      const statusCode = error?.response?.status;
      const isAuthError = statusCode === 401;

      if (isAuthError) {
        localStorage.clear();
        history.push(`/totem/${slug}`);

        return;
      }

      const wasNotified = notifyByCode(error?.response?.data?.code);

      if (wasNotified) toReset();
      else {
        notification.displayError(
          intl.formatMessage({
            id: "api.error." + error.response?.data?.code,
          })
        );
      }
    } finally {
      setWaitingLoadingButton(false);
    }
  }, [
    cpfValue,
    passportValue,
    isPortuguese,
    isEnglish,
    intl,
    notification,
    dispatch,
  ]);

  // Funções para o teclado virtual
  const handleVirtualKeyPress = useCallback((key) => {
    setPassportValue((prev) => prev + key);
  }, []);

  const handleVirtualBackspace = useCallback(() => {
    setPassportValue((prev) => prev.slice(0, -1));
  }, []);

  const handleVirtualClear = useCallback(() => {
    setPassportValue("");
  }, []);

  const handleVirtualKeyboardToggle = useCallback(() => {
    setShowVirtualKeyboard(!showVirtualKeyboard);
  }, [showVirtualKeyboard]);

  const onIdle = () => {
    resetProcess(true);
    resetModalByCode();
    resetLanguage();
    returnBegin();
  };

  const handleLogout = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowVirtualKeyboard(false);
    setShowLogoutModal(true);
  }, []);

  const handleReprintLastCredential = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowVirtualKeyboard(false);
    setShowReprintModal(true);
  }, []);

  const handleReprintLastCredentialConfirm = useCallback(
    async ({ password, action, justification }) => {
      setWaitingLoadingButton(true);

      const executePrintFlow = async (data) => {
        const { code, reportOutputList } = data;

        if (code !== CONSTANT_RESPONSE_CODES.reprintedSuccess) {
          notification.displayError(
            intl.formatMessage({ id: "api.error." + code })
          );
          return;
        }

        if (!Array.isArray(reportOutputList) || reportOutputList.length === 0) {
          notification.displayError(
            intl.formatMessage({ id: "api.error.-15028" })
          );
          return;
        }

        const pdfDoc = await PDFDocument.create();

        // Modo STAMP: PDF de etiqueta (257x141)
        // Modo TEMPLATE: PDF A4 com template
        const isStampMode = printConfiguration !== "TEMPLATE";

        for (const item of reportOutputList) {
          let page;
          let pageWidth, pageHeight;

          if (isStampMode) {
            // Dimensões da etiqueta (Jasper Report)
            const LABEL_WIDTH = 257;
            const LABEL_HEIGHT = 141;
            page = pdfDoc.addPage([LABEL_WIDTH, LABEL_HEIGHT]);
            pageWidth = LABEL_WIDTH;
            pageHeight = LABEL_HEIGHT;
          } else {
            // ===== BASE (BACKGROUND) - Só usa template se printConfiguration for "TEMPLATE" =====
            const templateBase64 = templateCache[item.baseTemplateS3FileKey];

            if (!templateBase64) {
              notification.displayError(
                intl.formatMessage({ id: "template.not.found" })
              );
              return;
            }

            page = pdfDoc.addPage([595.28, 841.89]); // A4
            pageWidth = page.getWidth();
            pageHeight = page.getHeight();

            // Desenha o template
            const baseImageBytes = Uint8Array.from(atob(templateBase64), (c) =>
              c.charCodeAt(0)
            );

            const baseImage = await pdfDoc.embedPng(baseImageBytes);

            page.drawImage(baseImage, {
              x: 0,
              y: 0,
              width: pageWidth,
              height: pageHeight,
            });
          }

          // ===== CREDENTIAL =====
          const credentialImageBytes = Uint8Array.from(
            atob(item.credentialOutput.file),
            (c) => c.charCodeAt(0)
          );

          const credentialImage = await pdfDoc.embedPng(credentialImageBytes);

          if (isStampMode) {
            // Modo STAMP: Credencial preenche toda a etiqueta
            page.drawImage(credentialImage, {
              x: 0,
              y: 0,
              width: pageWidth,
              height: pageHeight,
            });
          } else {
            // Modo TEMPLATE: Duas credenciais lado a lado no A4
            const aspectRatio = credentialImage.height / credentialImage.width;
            const credentialWidth = pageWidth * 0.49;
            const credentialHeight = credentialWidth * aspectRatio;
            const backgroundCredencialHeight = pageWidth * 0.41;

            const topOffset = pageHeight * 0.66;
            const topOffsetBackgroundCredencial = pageHeight * 0.61;
            const gap = pageWidth * 0.01;

            const leftX = (pageWidth - credentialWidth * 2 - gap) / 2;
            const rightX = leftX + credentialWidth + gap;

            // FUNDO BRANCO – ESQUERDA
            page.drawRectangle({
              x: leftX,
              y: topOffsetBackgroundCredencial,
              width: credentialWidth,
              height: backgroundCredencialHeight,
              color: rgb(1, 1, 1),
            });

            // ESQUERDA (NORMAL)
            page.drawImage(credentialImage, {
              x: leftX,
              y: topOffset,
              width: credentialWidth,
              height: credentialHeight,
            });

            // FUNDO BRANCO – DIREITA
            page.drawRectangle({
              x: rightX,
              y: topOffsetBackgroundCredencial,
              width: credentialWidth,
              height: backgroundCredencialHeight,
              color: rgb(1, 1, 1),
            });

            // DIREITA (ESPELHADA)
            page.drawImage(credentialImage, {
              x: rightX,
              y: topOffset,
              width: credentialWidth,
              height: credentialHeight,
            });
          }
        }

        const pdfBytes = await pdfDoc.save();
        printPdfKioskSafe(pdfBytes);

        toReset();
        setShowReprintModal(false);
      };

      try {
        const token = getTokenFromLocalStorage();

        const response = await reprintCredentialTotem(token, {
          extension: "png",
          password,
          action,
          reason: justification,
        });

        await executePrintFlow(response.data);
        const wasNotified = notifyByCode(response?.data?.code);
        if (wasNotified) toReset();
      } catch (error) {
        // Se token vencido (401), redirecionar para login do slug
        if (error.response?.status === 401) {
          console.warn(
            "[Totem] Token expirado ao reimprimir credencial. Redirecionando para login."
          );
          clearLocalStorageOnExit();
          history.push(`/totem/${slug}`);
          return;
        }

        const errorCode = error?.response?.data?.code;

        const wasNotified = notifyByCode(errorCode);
        if (wasNotified) toReset();
        else {
          notification.displayError(
            intl.formatMessage({
              id: "api.error." + errorCode,
            })
          );
        }
      } finally {
        setWaitingLoadingButton(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [intl, notification, printConfiguration, templateCache]
  );

  const handleLogoutConfirm = useCallback(
    async (code) => {
      try {
        setWaitingLoadingButton(true);

        // IMPORTANTE: Parar heartbeat ANTES de fazer logout
        stopHeartbeat();

        const token = getTokenFromLocalStorage();
        const responseShutdown = await logoutShutdownTotem(token, slug, code);

        if (
          responseShutdown.status === 200 &&
          responseShutdown.data.code === 50011
        ) {
          // Limpar dados da sessão MAS MANTER posição salva no localStorage
          clearLocalStorageOnExit();
          setShowLogoutModal(false);
          setWaitingLoadingButton(false);
          notification.displaySuccess(
            intl.formatMessage({ id: "logout.notification.success" })
          );
          history.push(`/totem/${slug}`);
        }
      } catch (error) {
        if (
          error.response.status === 400 &&
          error.response.data.code === -50004
        ) {
          notification.displayError(
            intl.formatMessage({
              id: "logout.notification.error.invalidAccessCode",
            })
          );
        } else {
          notification.displayError(
            intl.formatMessage({ id: "logout.notification.error.unexpected" })
          );
        }
      } finally {
        setWaitingLoadingButton(false);
      }
    },
    [history, slug, stopHeartbeat, notification, intl]
  );

  const handleLogoutCancel = useCallback(() => {
    setShowLogoutModal(false);
  }, []);

  const handleReprintLastCredentialCancel = useCallback(() => {
    setShowReprintModal(false);
  }, []);

  const returnBegin = () => {
    setViewCredentials(false);
    setShowLogoutModal(false);
    setShowReprintModal(false);
    setViewForms(true);
  };

  const toReset = () => {
    timeoutRef.current = setTimeout(() => {
      resetModalByCode();
      resetProcess();
      resetLanguage();
      returnBegin();
    }, 10000);
  };

  const notifyByCode = (code) => {
    switch (code) {
      case CONSTANT_RESPONSE_CODES.noCredentialAssociated:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({
            id: "selfService.error.noCredentialAssociated",
          }),
          message: intl.formatMessage({ id: "selfService.error.print.2" }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.alreadyPrinted:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({
            id: "selfService.error.alreadyPrinted",
          }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.unregisteredContributor:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({
            id: "selfService.error.unregisteredContributor",
          }),
          message: intl.formatMessage({ id: "selfService.error.print.2" }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case -13031:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({
            id: "selfService.error.badgePrint.title",
          }),
          message: intl.formatMessage({
            id:
              intl.locale === "en"
                ? "selfService.error.badgePrint.message.en"
                : "selfService.error.badgePrint.message",
          }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case -50012:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({
            id: "selfService.error.credentialTypeNotAllowed",
          }),
          message: intl.formatMessage({ id: "selfService.error.print.2" }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.printedError:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({ id: "selfService.error.print.1" }),
          message: intl.formatMessage({ id: "selfService.error.print.2" }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.printedSuccess:
        setInfoNotificationModalByCode({
          printedCredential: true,
          title: intl.formatMessage({ id: "selfService.success.print.1" }),
          message: intl.formatMessage({ id: "selfService.success.print.2" }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconPrinted: () => <AiOutlinePrinter color="#2c3e50" size={90} />,
          backgroundColor: "#ffffff",
          textColor: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.reprintedSuccess:
        setInfoNotificationModalByCode({
          printedCredential: true,
          title: intl.formatMessage({ id: "selfService.success.print.1" }),
          message: intl.formatMessage({ id: "selfService.success.print.2" }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconPrinted: () => <AiOutlinePrinter color="#2c3e50" size={90} />,
          backgroundColor: "#ffffff",
          textColor: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.multipleAssociatedCredentials:
        setInfoNotificationModalByCode({
          printedCredential: true,
          title: intl.formatMessage({
            id: "selfService.success.multipleAssociatedCredentials",
          }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconPrinted: () => <AiOutlinePrinter color="#2c3e50" size={90} />,
          backgroundColor: "#ffffff",
          textColor: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.cannotPrintOneOrMoreCredentials:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({ id: "selfService.error_print" }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      case CONSTANT_RESPONSE_CODES.permissionDenied:
        setInfoNotificationModalByCode({
          printedCredential: false,
          title: intl.formatMessage({
            id: "selfService.error.badgePrint.title",
          }),
          message: intl.formatMessage({
            id:
              intl.locale === "en"
                ? "selfService.error.badgePrint.message.en"
                : "selfService.error.badgePrint.message",
          }),
          onClose: () => {
            resetModalByCode();
            resetProcess();
            resetLanguage();
            returnBegin();
          },
          IconWarning: () => <PiWarningCircle color="#ffffff" size={90} />,
          backgroundColor: "rgb(255, 56, 56)",
          textColor: "#ffffff",
          bgButtonOk: "#ffffff",
          textButtonOk: "#2c3e50",
        });

        setIsOpenModalByCode(true);
        return true;

      default:
        return false;
    }
  };

  const sendPrintCredential = (credential) => {
    setWaitingForPrintAssemble(true);
    setSelectedCredential({
      credentialId: credential.id,
      credentialCompanyName: credential.company_name,
    });
  };

  return (
    <LoadingOverlay
      additionalLoading={waitingForPrintAssemble || waitingLoadingButton}
    >
      <Container>
        <BackgroundImageContainer>
          <BackgroundImage src={storedTotem?.background_image} />
        </BackgroundImageContainer>
        <TopRightContainer>
          <Tooltip
            title={intl.formatMessage({ id: "reprint_last_credential" })}
          >
            <ActionButton
              reprint
              onClick={handleReprintLastCredential}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
              title={intl.formatMessage({ id: "reprint_last_credential" })}
            >
              <FaPrint size={20} color="#dc3545" />
            </ActionButton>
          </Tooltip>

          <LanguageSelectorContainer>
            <LanguageSelector />
          </LanguageSelectorContainer>

          <Tooltip title={intl.formatMessage({ id: "logout" })}>
            <ActionButton
              onClick={handleLogout}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
            >
              <SignOut size={20} color="#dc3545" />
            </ActionButton>
          </Tooltip>
        </TopRightContainer>
        {viewForms && (
          <>
            <AnimatedContainer>
              <LeftSection>
                {/* {storedTotem?.url_logo !==
                  "The logo image cannot be resized. It may be that the image is corrupted." && (
                  <Logo src={storedTotem?.url_logo} />
                )} */}
              </LeftSection>

              <RightSection>
                <CpfSection>
                  <CpfLabel>
                    {isPortuguese
                      ? intl.formatMessage({ id: "selfService.cpf.label" })
                      : intl.formatMessage({
                          id: "selfService.passport.label",
                        })}
                  </CpfLabel>
                  {isPortuguese ? (
                    <CpfInput
                      value={cpfValue}
                      placeholder={intl.formatMessage({
                        id: "selfService.cpf.placeholder",
                      })}
                      readOnly
                    />
                  ) : (
                    <CpfInput
                      ref={passportInputRef}
                      value={passportValue}
                      placeholder={intl.formatMessage({
                        id: "selfService.passport.placeholder",
                      })}
                      readOnly
                      onClick={handleVirtualKeyboardToggle}
                    />
                  )}
                </CpfSection>

                {isPortuguese && (
                  <Calculator>
                    <NumberGrid>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                        <NumberButton
                          key={number}
                          onClick={() => handleNumberClick(number)}
                        >
                          {number}
                        </NumberButton>
                      ))}

                      <BackspaceButton onClick={handleBackspace}>
                        ⌫
                      </BackspaceButton>
                      <NumberButton onClick={() => handleNumberClick("0")}>
                        0
                      </NumberButton>
                      <SubmitButton
                        disabled={waitingLoadingButton}
                        onClick={handleSubmit}
                      >
                        {intl.formatMessage({
                          id: "selfService.calculator.submit",
                        })}
                      </SubmitButton>
                    </NumberGrid>
                  </Calculator>
                )}

                {isEnglish && (
                  <SubmitButtonPP
                    disabled={waitingLoadingButton}
                    onClick={handleSubmit}
                    style={{ marginTop: "20px", width: "100%" }}
                  >
                    {intl.formatMessage({
                      id: "selfService.calculator.submit",
                    })}
                  </SubmitButtonPP>
                )}
              </RightSection>
            </AnimatedContainer>

            {isEnglish && (
              <VirtualKeyboard
                isVisible={showVirtualKeyboard}
                onKeyPress={handleVirtualKeyPress}
                onBackspace={handleVirtualBackspace}
                onClear={handleVirtualClear}
                onClose={() => setShowVirtualKeyboard(false)}
                onEnter={handleSubmit}
              />
            )}
          </>
        )}
        {viewCredentials && (
          <AnimatedContainer>
            <CredencialsWrapper>
              <AreaTitle>
                <ReturnButton onClick={returnBegin}>
                  <IoReturnDownBackOutline size={30} />
                  {intl.formatMessage({ id: "cancel" })}
                </ReturnButton>

                <CredentialsPageTitle>
                  {intl.formatMessage({
                    id: "selfService.check_your_data",
                  })}
                </CredentialsPageTitle>
              </AreaTitle>

              <CredentialsListContainer>
                {credentialsList.length > 0 && (
                  <>
                    {credentialsList.map((credential) => (
                      <CredentialCard key={credential.id}>
                        <LabelCard>
                          <span>{intl.formatMessage({ id: "name" })}: </span>
                          {credential.name}
                        </LabelCard>

                        <LabelCard>
                          <span>
                            {intl.formatMessage({
                              id: "selfService.name_on_credential",
                            })}
                            :
                          </span>{" "}
                          {credential.name_on_credential}
                        </LabelCard>

                        <LabelCard>
                          <span>
                            {intl.formatMessage({ id: "selfService.role" })}:
                          </span>{" "}
                          {credential.role}
                        </LabelCard>

                        <LabelCard>
                          <span>{intl.formatMessage({ id: "company" })}:</span>{" "}
                          {credential.company_name_on_credential ||
                            credential.company_name}
                        </LabelCard>

                        <ContainerButton>
                          {credential.printed === true ? (
                            <PrintButton printed>
                              {intl.formatMessage({
                                id: "selfService.error.alreadyPrinted",
                              })}
                            </PrintButton>
                          ) : (
                            <PrintButton
                              type="primary"
                              onClick={() => sendPrintCredential(credential)}
                              disabled={waitingForPrintAssemble}
                            >
                              <div>
                                <BsPrinterFill
                                  size={30}
                                  style={{ marginTop: "8px" }}
                                />
                              </div>
                              {intl.formatMessage({ id: "print" })}
                            </PrintButton>
                          )}
                        </ContainerButton>
                      </CredentialCard>
                    ))}
                  </>
                )}
              </CredentialsListContainer>
            </CredencialsWrapper>
          </AnimatedContainer>
        )}
        <IdleTimer
          timeout={IDLE_TIMEOUT}
          onIdle={onIdle}
          debounce={DEBOUNCE_TIME}
        />
        <AccessCodeConfirmationModal
          isLoadingButton={waitingLoadingButton}
          typePassword={true}
          placeholder={intl.formatMessage({ id: "logout.input.placeholder" })}
          visible={showLogoutModal}
          onCancel={handleLogoutCancel}
          onConfirm={handleLogoutConfirm}
          title={intl.formatMessage(
            { id: "logout.confirmation.title" },
            { defaultMessage: "Confirmação de Logout" }
          )}
          description={(() => {
            const currentPosition = getTotemPosition(slug);
            return (
              intl.formatMessage(
                { id: "logout.confirmation.description" },
                {
                  defaultMessage:
                    "Digite o código de acesso para confirmar o logout:",
                }
              ) +
              (currentPosition
                ? "\n\n" +
                  intl.formatMessage(
                    { id: "totem.position.current" },
                    { position: currentPosition }
                  )
                : "")
            );
          })()}
        />
        <AccessCodeConfirmationModal
          isLoadingButton={waitingLoadingButton}
          typePassword={true}
          isReprint={true}
          placeholder={intl.formatMessage({ id: "logout.input.placeholder" })}
          visible={showReprintModal}
          onCancel={handleReprintLastCredentialCancel}
          onConfirm={handleReprintLastCredentialConfirm}
          title={intl.formatMessage(
            { id: "reprint_last_credential" },
            { defaultMessage: "Confirmação de Reimpressão" }
          )}
        />
        ∑
        <ModalNotification
          isOpen={isOpenModalByCode}
          onClose={infoNotificationModalByCode?.onClose}
          printedCredential={infoNotificationModalByCode?.printedCredential}
          title={infoNotificationModalByCode?.title}
          message={infoNotificationModalByCode?.message}
          IconPrinted={infoNotificationModalByCode?.IconPrinted}
          IconWarning={infoNotificationModalByCode?.IconWarning}
          backgroundColor={infoNotificationModalByCode?.backgroundColor}
          textColor={infoNotificationModalByCode?.textColor}
          bgButtonOk={infoNotificationModalByCode?.bgButtonOk}
          textButtonOk={infoNotificationModalByCode?.textButtonOk}
        />
        <CredenticalImagePreview
          fncToReset={toReset}
          fncToNotifyByCode={notifyByCode}
          credentialData={selectedCredential}
          activeToken={getTokenFromLocalStorage()}
          viewCredentials={viewCredentials}
          handleWaitingForPrintAssemble={handleWaitingForPrintAssemble}
          templateCache={templateCache}
          printConfiguration={printConfiguration}
        />
      </Container>
    </LoadingOverlay>
  );
};
